module.exports = __webpack_public_path__ + "static/media/solution-ec.6663d6ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/solution-ec.svg
// module id = 169
// module chunks = 6